// extracted by mini-css-extract-plugin
export var actionText = "_oh-4";
export var container = "_oh-0";
export var leftSection = "_oh-1";
export var rightSection = "_oh-2";
export var settingsButton = "_oh-6";
export var settingsIcon = "_oh-7";
export var shortcut = "_oh-5";
export var shortcutGroup = "_oh-3";